// extracted by mini-css-extract-plugin
export var emptyState = "_6g-d";
export var statCard = "_6g-c";
export var table = "_6g-0";
export var tableCell = "_6g-4";
export var tableCellClickable = "_6g-5 _6g-4";
export var tableCellDefault = "_6g-6 _6g-4";
export var tableCellEmpty = "_6g-8";
export var tableCellWithValue = "_6g-7";
export var tableContainer = "_6g-e";
export var tableHeaderWeight = "_6g-1";
export var tableHeaderZone = "_6g-2";
export var tableRowHeader = "_6g-3";
export var viewModeButton = "_6g-9";
export var viewModeButtonActive = "_6g-a _6g-9";
export var viewModeButtonInactive = "_6g-b _6g-9";